import { ChangeDetectionStrategy, Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import {
    IChecklistReportAttentionRequiredData,
    IChecklist2ReportAttentionRequired,
} from '../../shared/fi-checklist2-report';
import { FiReportWidgetDetailsBaseDirective } from '../../shared/report-widget-details-base.directive';

@Component({
    selector: 'fi-deviations-report',
    templateUrl: './deviations-report.component.html',
    styleUrls: ['./deviations-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-deviations-report' },
    standalone: false,
})
export class FiDeviationsReportComponent extends FiReportWidgetDetailsBaseDirective {
    @Output() onOpenAnswerDetails = new EventEmitter<IChecklistReportAttentionRequiredData>();
    attentionRequiredItems: IChecklist2ReportAttentionRequired[] = [];

    openAnswerDetails(attentionRequiredData: IChecklistReportAttentionRequiredData) {
        this.onOpenAnswerDetails.emit(attentionRequiredData);
    }

    setAttentionRequiredItems(newAttentionRequiredItems: IChecklist2ReportAttentionRequired[]) {
        this.attentionRequiredItems = [...newAttentionRequiredItems];
    }
}
